import { result, isEmpty } from 'libraries/lodash'
import { AppDispatch } from 'redux/store'
import { QASection, QASectionNode } from 'interfaces/qa'
import { Flavour } from 'types/Flavour'
import { QA_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'
import {
  SET_QA_SECTION_ID,
  SET_QA_ROOT_SECTIONS,
  SET_QA_SECTIONS_MAP,
  SET_QA_SECTIONS,
  SET_QA_PICKED_SECTION,
  SET_QA_NODE_MAP,
  SET_QA_KEYWORD,
  SET_QA_SHOW_FAVOURITES_ONLY,
  SET_MOUSEABILITY_REFERENCE
} from './types'

export const setQASectionId = (sectionId: string): { type: typeof SET_QA_SECTION_ID, sectionId: string } => ({
  type: SET_QA_SECTION_ID,
  sectionId
})

export const setQAPickedSection = (flavour: Flavour, sections: Record<Flavour, QASectionNode>) => {
  return (dispatch: AppDispatch, _: any) => {
    if (!isEmpty(sections)) {
      const pickedSection = sections[flavour]
      dispatch({
        type: SET_QA_PICKED_SECTION,
        pickedSection
      })

      const nodeMap = new Map()
      Object.entries(pickedSection.nodes).forEach(([id, value]) => nodeMap.set(id, value))
      dispatch(setQANodeMap(nodeMap))
    }
  }
}

const setQANodeMap = (nodeMap: Map<string, QASection>): { type: typeof SET_QA_NODE_MAP, nodeMap: Map<string, QASection> } => ({
  type: SET_QA_NODE_MAP,
  nodeMap
})

export const setQARootSections = (pickedSection: QASectionNode) => {
  return (dispatch: AppDispatch, _: any) => {
    const rootSections = result(
      pickedSection,
      ['nodes', pickedSection.root, 'childSections'],
      []
    ).map(id => ({
      ...pickedSection.nodes[id],
      empty: pickedSection.nodes[id].childSections.length <= 0
    }))

    dispatch({
      type: SET_QA_ROOT_SECTIONS,
      rootSections
    })
  }
}

const setQaSectionsMap = (sections: Record<Flavour, QASectionNode>) => {
  return (dispatch: AppDispatch, _: any) => {
    const qaSectionsMap: Map<string, QASection> = new Map()

    Object.entries(sections).forEach(([flavour, { nodes }]) => {
      const entries: Array<[string, QASection]> = Object.entries(nodes)
      entries.shift()
      entries.forEach(([sectionId, { id, ...fields }]) => {
        qaSectionsMap.set(sectionId, { ...fields, flavour: flavour as Flavour })
      })
    })

    dispatch({
      type: SET_QA_SECTIONS_MAP,
      sectionsMap: qaSectionsMap
    })
  }
}

export const setQASections = (sections: Record<Flavour, QASectionNode>) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_QA_SECTIONS,
      sections
    })
    dispatch(setQaSectionsMap(sections) as any)
  }
}

export const setQAKeyword = (keyword: string): { type: typeof SET_QA_KEYWORD, keyword: string } => ({
  type: SET_QA_KEYWORD,
  keyword
})

export const setQAShowFavouritesOnly = (show: boolean): { type: typeof SET_QA_SHOW_FAVOURITES_ONLY, showFavouritesOnly: boolean } => {
  localStorage.setItem(QA_FAVOURITES_ONLY_KEY, JSON.stringify(show))
  return {
    type: SET_QA_SHOW_FAVOURITES_ONLY,
    showFavouritesOnly: show
  }
}

export const setMouseabilityReference = (mouseabilityReference: string): { type: typeof SET_MOUSEABILITY_REFERENCE, mouseabilityReference: string } => ({
  type: SET_MOUSEABILITY_REFERENCE,
  mouseabilityReference
})
